// Core
// import { useEffect } from "react"
// import { navigate } from "gatsby"

// export default () => {
//   useEffect(() => {
//     // navigate("/site/")
//     // window.location.replace("https://oceanodagraca.com.br/pagamento/")
//   }, [])

//   return null
// }

// Core
import React from "react"
import Site from "./site"

export default function index() {
  return <Site />
}
